import Menu from '@material-ui/core/Menu';
import Button from '@material-ui/core/Button';
import {MouseEvent, useState, PropsWithChildren} from 'react';

type Props = {
  // eslint-disable-next-line react/require-default-props
  title?: string;
} & PropsWithChildren<{}>;

const TableMenu = (props: Props) => {
  const {children, title = 'Acciones'} = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) =>
    setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        id="table-menu-btn"
        aria-controls="simple-menu"
        aria-haspopup="true"
        variant="outlined"
        color="primary"
        onClick={handleClick}
      >
        {title}
      </Button>
      <Menu
        id="table-menu"
        anchorEl={anchorEl}
        keepMounted
        style={{width: '100%'}}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {children}
      </Menu>
    </>
  );
};

export default TableMenu;
